// SPDX-License-Identifier: MIT
export const WORDLIST = [
    '가격',
    '가끔',
    '가난',
    '가능',
    '가득',
    '가르침',
    '가뭄',
    '가방',
    '가상',
    '가슴',
    '가운데',
    '가을',
    '가이드',
    '가입',
    '가장',
    '가정',
    '가족',
    '가죽',
    '각오',
    '각자',
    '간격',
    '간부',
    '간섭',
    '간장',
    '간접',
    '간판',
    '갈등',
    '갈비',
    '갈색',
    '갈증',
    '감각',
    '감기',
    '감소',
    '감수성',
    '감자',
    '감정',
    '갑자기',
    '강남',
    '강당',
    '강도',
    '강력히',
    '강변',
    '강북',
    '강사',
    '강수량',
    '강아지',
    '강원도',
    '강의',
    '강제',
    '강조',
    '같이',
    '개구리',
    '개나리',
    '개방',
    '개별',
    '개선',
    '개성',
    '개인',
    '객관적',
    '거실',
    '거액',
    '거울',
    '거짓',
    '거품',
    '걱정',
    '건강',
    '건물',
    '건설',
    '건조',
    '건축',
    '걸음',
    '검사',
    '검토',
    '게시판',
    '게임',
    '겨울',
    '견해',
    '결과',
    '결국',
    '결론',
    '결석',
    '결승',
    '결심',
    '결정',
    '결혼',
    '경계',
    '경고',
    '경기',
    '경력',
    '경복궁',
    '경비',
    '경상도',
    '경영',
    '경우',
    '경쟁',
    '경제',
    '경주',
    '경찰',
    '경치',
    '경향',
    '경험',
    '계곡',
    '계단',
    '계란',
    '계산',
    '계속',
    '계약',
    '계절',
    '계층',
    '계획',
    '고객',
    '고구려',
    '고궁',
    '고급',
    '고등학생',
    '고무신',
    '고민',
    '고양이',
    '고장',
    '고전',
    '고집',
    '고춧가루',
    '고통',
    '고향',
    '곡식',
    '골목',
    '골짜기',
    '골프',
    '공간',
    '공개',
    '공격',
    '공군',
    '공급',
    '공기',
    '공동',
    '공무원',
    '공부',
    '공사',
    '공식',
    '공업',
    '공연',
    '공원',
    '공장',
    '공짜',
    '공책',
    '공통',
    '공포',
    '공항',
    '공휴일',
    '과목',
    '과일',
    '과장',
    '과정',
    '과학',
    '관객',
    '관계',
    '관광',
    '관념',
    '관람',
    '관련',
    '관리',
    '관습',
    '관심',
    '관점',
    '관찰',
    '광경',
    '광고',
    '광장',
    '광주',
    '괴로움',
    '굉장히',
    '교과서',
    '교문',
    '교복',
    '교실',
    '교양',
    '교육',
    '교장',
    '교직',
    '교통',
    '교환',
    '교훈',
    '구경',
    '구름',
    '구멍',
    '구별',
    '구분',
    '구석',
    '구성',
    '구속',
    '구역',
    '구입',
    '구청',
    '구체적',
    '국가',
    '국기',
    '국내',
    '국립',
    '국물',
    '국민',
    '국수',
    '국어',
    '국왕',
    '국적',
    '국제',
    '국회',
    '군대',
    '군사',
    '군인',
    '궁극적',
    '권리',
    '권위',
    '권투',
    '귀국',
    '귀신',
    '규정',
    '규칙',
    '균형',
    '그날',
    '그냥',
    '그늘',
    '그러나',
    '그룹',
    '그릇',
    '그림',
    '그제서야',
    '그토록',
    '극복',
    '극히',
    '근거',
    '근교',
    '근래',
    '근로',
    '근무',
    '근본',
    '근원',
    '근육',
    '근처',
    '글씨',
    '글자',
    '금강산',
    '금고',
    '금년',
    '금메달',
    '금액',
    '금연',
    '금요일',
    '금지',
    '긍정적',
    '기간',
    '기관',
    '기념',
    '기능',
    '기독교',
    '기둥',
    '기록',
    '기름',
    '기법',
    '기본',
    '기분',
    '기쁨',
    '기숙사',
    '기술',
    '기억',
    '기업',
    '기온',
    '기운',
    '기원',
    '기적',
    '기준',
    '기침',
    '기혼',
    '기획',
    '긴급',
    '긴장',
    '길이',
    '김밥',
    '김치',
    '김포공항',
    '깍두기',
    '깜빡',
    '깨달음',
    '깨소금',
    '껍질',
    '꼭대기',
    '꽃잎',
    '나들이',
    '나란히',
    '나머지',
    '나물',
    '나침반',
    '나흘',
    '낙엽',
    '난방',
    '날개',
    '날씨',
    '날짜',
    '남녀',
    '남대문',
    '남매',
    '남산',
    '남자',
    '남편',
    '남학생',
    '낭비',
    '낱말',
    '내년',
    '내용',
    '내일',
    '냄비',
    '냄새',
    '냇물',
    '냉동',
    '냉면',
    '냉방',
    '냉장고',
    '넥타이',
    '넷째',
    '노동',
    '노란색',
    '노력',
    '노인',
    '녹음',
    '녹차',
    '녹화',
    '논리',
    '논문',
    '논쟁',
    '놀이',
    '농구',
    '농담',
    '농민',
    '농부',
    '농업',
    '농장',
    '농촌',
    '높이',
    '눈동자',
    '눈물',
    '눈썹',
    '뉴욕',
    '느낌',
    '늑대',
    '능동적',
    '능력',
    '다방',
    '다양성',
    '다음',
    '다이어트',
    '다행',
    '단계',
    '단골',
    '단독',
    '단맛',
    '단순',
    '단어',
    '단위',
    '단점',
    '단체',
    '단추',
    '단편',
    '단풍',
    '달걀',
    '달러',
    '달력',
    '달리',
    '닭고기',
    '담당',
    '담배',
    '담요',
    '담임',
    '답변',
    '답장',
    '당근',
    '당분간',
    '당연히',
    '당장',
    '대규모',
    '대낮',
    '대단히',
    '대답',
    '대도시',
    '대략',
    '대량',
    '대륙',
    '대문',
    '대부분',
    '대신',
    '대응',
    '대장',
    '대전',
    '대접',
    '대중',
    '대책',
    '대출',
    '대충',
    '대통령',
    '대학',
    '대한민국',
    '대합실',
    '대형',
    '덩어리',
    '데이트',
    '도대체',
    '도덕',
    '도둑',
    '도망',
    '도서관',
    '도심',
    '도움',
    '도입',
    '도자기',
    '도저히',
    '도전',
    '도중',
    '도착',
    '독감',
    '독립',
    '독서',
    '독일',
    '독창적',
    '동화책',
    '뒷모습',
    '뒷산',
    '딸아이',
    '마누라',
    '마늘',
    '마당',
    '마라톤',
    '마련',
    '마무리',
    '마사지',
    '마약',
    '마요네즈',
    '마을',
    '마음',
    '마이크',
    '마중',
    '마지막',
    '마찬가지',
    '마찰',
    '마흔',
    '막걸리',
    '막내',
    '막상',
    '만남',
    '만두',
    '만세',
    '만약',
    '만일',
    '만점',
    '만족',
    '만화',
    '많이',
    '말기',
    '말씀',
    '말투',
    '맘대로',
    '망원경',
    '매년',
    '매달',
    '매력',
    '매번',
    '매스컴',
    '매일',
    '매장',
    '맥주',
    '먹이',
    '먼저',
    '먼지',
    '멀리',
    '메일',
    '며느리',
    '며칠',
    '면담',
    '멸치',
    '명단',
    '명령',
    '명예',
    '명의',
    '명절',
    '명칭',
    '명함',
    '모금',
    '모니터',
    '모델',
    '모든',
    '모범',
    '모습',
    '모양',
    '모임',
    '모조리',
    '모집',
    '모퉁이',
    '목걸이',
    '목록',
    '목사',
    '목소리',
    '목숨',
    '목적',
    '목표',
    '몰래',
    '몸매',
    '몸무게',
    '몸살',
    '몸속',
    '몸짓',
    '몸통',
    '몹시',
    '무관심',
    '무궁화',
    '무더위',
    '무덤',
    '무릎',
    '무슨',
    '무엇',
    '무역',
    '무용',
    '무조건',
    '무지개',
    '무척',
    '문구',
    '문득',
    '문법',
    '문서',
    '문제',
    '문학',
    '문화',
    '물가',
    '물건',
    '물결',
    '물고기',
    '물론',
    '물리학',
    '물음',
    '물질',
    '물체',
    '미국',
    '미디어',
    '미사일',
    '미술',
    '미역',
    '미용실',
    '미움',
    '미인',
    '미팅',
    '미혼',
    '민간',
    '민족',
    '민주',
    '믿음',
    '밀가루',
    '밀리미터',
    '밑바닥',
    '바가지',
    '바구니',
    '바나나',
    '바늘',
    '바닥',
    '바닷가',
    '바람',
    '바이러스',
    '바탕',
    '박물관',
    '박사',
    '박수',
    '반대',
    '반드시',
    '반말',
    '반발',
    '반성',
    '반응',
    '반장',
    '반죽',
    '반지',
    '반찬',
    '받침',
    '발가락',
    '발걸음',
    '발견',
    '발달',
    '발레',
    '발목',
    '발바닥',
    '발생',
    '발음',
    '발자국',
    '발전',
    '발톱',
    '발표',
    '밤하늘',
    '밥그릇',
    '밥맛',
    '밥상',
    '밥솥',
    '방금',
    '방면',
    '방문',
    '방바닥',
    '방법',
    '방송',
    '방식',
    '방안',
    '방울',
    '방지',
    '방학',
    '방해',
    '방향',
    '배경',
    '배꼽',
    '배달',
    '배드민턴',
    '백두산',
    '백색',
    '백성',
    '백인',
    '백제',
    '백화점',
    '버릇',
    '버섯',
    '버튼',
    '번개',
    '번역',
    '번지',
    '번호',
    '벌금',
    '벌레',
    '벌써',
    '범위',
    '범인',
    '범죄',
    '법률',
    '법원',
    '법적',
    '법칙',
    '베이징',
    '벨트',
    '변경',
    '변동',
    '변명',
    '변신',
    '변호사',
    '변화',
    '별도',
    '별명',
    '별일',
    '병실',
    '병아리',
    '병원',
    '보관',
    '보너스',
    '보라색',
    '보람',
    '보름',
    '보상',
    '보안',
    '보자기',
    '보장',
    '보전',
    '보존',
    '보통',
    '보편적',
    '보험',
    '복도',
    '복사',
    '복숭아',
    '복습',
    '볶음',
    '본격적',
    '본래',
    '본부',
    '본사',
    '본성',
    '본인',
    '본질',
    '볼펜',
    '봉사',
    '봉지',
    '봉투',
    '부근',
    '부끄러움',
    '부담',
    '부동산',
    '부문',
    '부분',
    '부산',
    '부상',
    '부엌',
    '부인',
    '부작용',
    '부장',
    '부정',
    '부족',
    '부지런히',
    '부친',
    '부탁',
    '부품',
    '부회장',
    '북부',
    '북한',
    '분노',
    '분량',
    '분리',
    '분명',
    '분석',
    '분야',
    '분위기',
    '분필',
    '분홍색',
    '불고기',
    '불과',
    '불교',
    '불꽃',
    '불만',
    '불법',
    '불빛',
    '불안',
    '불이익',
    '불행',
    '브랜드',
    '비극',
    '비난',
    '비닐',
    '비둘기',
    '비디오',
    '비로소',
    '비만',
    '비명',
    '비밀',
    '비바람',
    '비빔밥',
    '비상',
    '비용',
    '비율',
    '비중',
    '비타민',
    '비판',
    '빌딩',
    '빗물',
    '빗방울',
    '빗줄기',
    '빛깔',
    '빨간색',
    '빨래',
    '빨리',
    '사건',
    '사계절',
    '사나이',
    '사냥',
    '사람',
    '사랑',
    '사립',
    '사모님',
    '사물',
    '사방',
    '사상',
    '사생활',
    '사설',
    '사슴',
    '사실',
    '사업',
    '사용',
    '사월',
    '사장',
    '사전',
    '사진',
    '사촌',
    '사춘기',
    '사탕',
    '사투리',
    '사흘',
    '산길',
    '산부인과',
    '산업',
    '산책',
    '살림',
    '살인',
    '살짝',
    '삼계탕',
    '삼국',
    '삼십',
    '삼월',
    '삼촌',
    '상관',
    '상금',
    '상대',
    '상류',
    '상반기',
    '상상',
    '상식',
    '상업',
    '상인',
    '상자',
    '상점',
    '상처',
    '상추',
    '상태',
    '상표',
    '상품',
    '상황',
    '새벽',
    '색깔',
    '색연필',
    '생각',
    '생명',
    '생물',
    '생방송',
    '생산',
    '생선',
    '생신',
    '생일',
    '생활',
    '서랍',
    '서른',
    '서명',
    '서민',
    '서비스',
    '서양',
    '서울',
    '서적',
    '서점',
    '서쪽',
    '서클',
    '석사',
    '석유',
    '선거',
    '선물',
    '선배',
    '선생',
    '선수',
    '선원',
    '선장',
    '선전',
    '선택',
    '선풍기',
    '설거지',
    '설날',
    '설렁탕',
    '설명',
    '설문',
    '설사',
    '설악산',
    '설치',
    '설탕',
    '섭씨',
    '성공',
    '성당',
    '성명',
    '성별',
    '성인',
    '성장',
    '성적',
    '성질',
    '성함',
    '세금',
    '세미나',
    '세상',
    '세월',
    '세종대왕',
    '세탁',
    '센터',
    '센티미터',
    '셋째',
    '소규모',
    '소극적',
    '소금',
    '소나기',
    '소년',
    '소득',
    '소망',
    '소문',
    '소설',
    '소속',
    '소아과',
    '소용',
    '소원',
    '소음',
    '소중히',
    '소지품',
    '소질',
    '소풍',
    '소형',
    '속담',
    '속도',
    '속옷',
    '손가락',
    '손길',
    '손녀',
    '손님',
    '손등',
    '손목',
    '손뼉',
    '손실',
    '손질',
    '손톱',
    '손해',
    '솔직히',
    '솜씨',
    '송아지',
    '송이',
    '송편',
    '쇠고기',
    '쇼핑',
    '수건',
    '수년',
    '수단',
    '수돗물',
    '수동적',
    '수면',
    '수명',
    '수박',
    '수상',
    '수석',
    '수술',
    '수시로',
    '수업',
    '수염',
    '수영',
    '수입',
    '수준',
    '수집',
    '수출',
    '수컷',
    '수필',
    '수학',
    '수험생',
    '수화기',
    '숙녀',
    '숙소',
    '숙제',
    '순간',
    '순서',
    '순수',
    '순식간',
    '순위',
    '숟가락',
    '술병',
    '술집',
    '숫자',
    '스님',
    '스물',
    '스스로',
    '스승',
    '스웨터',
    '스위치',
    '스케이트',
    '스튜디오',
    '스트레스',
    '스포츠',
    '슬쩍',
    '슬픔',
    '습관',
    '습기',
    '승객',
    '승리',
    '승부',
    '승용차',
    '승진',
    '시각',
    '시간',
    '시골',
    '시금치',
    '시나리오',
    '시댁',
    '시리즈',
    '시멘트',
    '시민',
    '시부모',
    '시선',
    '시설',
    '시스템',
    '시아버지',
    '시어머니',
    '시월',
    '시인',
    '시일',
    '시작',
    '시장',
    '시절',
    '시점',
    '시중',
    '시즌',
    '시집',
    '시청',
    '시합',
    '시험',
    '식구',
    '식기',
    '식당',
    '식량',
    '식료품',
    '식물',
    '식빵',
    '식사',
    '식생활',
    '식초',
    '식탁',
    '식품',
    '신고',
    '신규',
    '신념',
    '신문',
    '신발',
    '신비',
    '신사',
    '신세',
    '신용',
    '신제품',
    '신청',
    '신체',
    '신화',
    '실감',
    '실내',
    '실력',
    '실례',
    '실망',
    '실수',
    '실습',
    '실시',
    '실장',
    '실정',
    '실질적',
    '실천',
    '실체',
    '실컷',
    '실태',
    '실패',
    '실험',
    '실현',
    '심리',
    '심부름',
    '심사',
    '심장',
    '심정',
    '심판',
    '쌍둥이',
    '씨름',
    '씨앗',
    '아가씨',
    '아나운서',
    '아드님',
    '아들',
    '아쉬움',
    '아스팔트',
    '아시아',
    '아울러',
    '아저씨',
    '아줌마',
    '아직',
    '아침',
    '아파트',
    '아프리카',
    '아픔',
    '아홉',
    '아흔',
    '악기',
    '악몽',
    '악수',
    '안개',
    '안경',
    '안과',
    '안내',
    '안녕',
    '안동',
    '안방',
    '안부',
    '안주',
    '알루미늄',
    '알코올',
    '암시',
    '암컷',
    '압력',
    '앞날',
    '앞문',
    '애인',
    '애정',
    '액수',
    '앨범',
    '야간',
    '야단',
    '야옹',
    '약간',
    '약국',
    '약속',
    '약수',
    '약점',
    '약품',
    '약혼녀',
    '양념',
    '양력',
    '양말',
    '양배추',
    '양주',
    '양파',
    '어둠',
    '어려움',
    '어른',
    '어젯밤',
    '어쨌든',
    '어쩌다가',
    '어쩐지',
    '언니',
    '언덕',
    '언론',
    '언어',
    '얼굴',
    '얼른',
    '얼음',
    '얼핏',
    '엄마',
    '업무',
    '업종',
    '업체',
    '엉덩이',
    '엉망',
    '엉터리',
    '엊그제',
    '에너지',
    '에어컨',
    '엔진',
    '여건',
    '여고생',
    '여관',
    '여군',
    '여권',
    '여대생',
    '여덟',
    '여동생',
    '여든',
    '여론',
    '여름',
    '여섯',
    '여성',
    '여왕',
    '여인',
    '여전히',
    '여직원',
    '여학생',
    '여행',
    '역사',
    '역시',
    '역할',
    '연결',
    '연구',
    '연극',
    '연기',
    '연락',
    '연설',
    '연세',
    '연속',
    '연습',
    '연애',
    '연예인',
    '연인',
    '연장',
    '연주',
    '연출',
    '연필',
    '연합',
    '연휴',
    '열기',
    '열매',
    '열쇠',
    '열심히',
    '열정',
    '열차',
    '열흘',
    '염려',
    '엽서',
    '영국',
    '영남',
    '영상',
    '영양',
    '영역',
    '영웅',
    '영원히',
    '영하',
    '영향',
    '영혼',
    '영화',
    '옆구리',
    '옆방',
    '옆집',
    '예감',
    '예금',
    '예방',
    '예산',
    '예상',
    '예선',
    '예술',
    '예습',
    '예식장',
    '예약',
    '예전',
    '예절',
    '예정',
    '예컨대',
    '옛날',
    '오늘',
    '오락',
    '오랫동안',
    '오렌지',
    '오로지',
    '오른발',
    '오븐',
    '오십',
    '오염',
    '오월',
    '오전',
    '오직',
    '오징어',
    '오페라',
    '오피스텔',
    '오히려',
    '옥상',
    '옥수수',
    '온갖',
    '온라인',
    '온몸',
    '온종일',
    '온통',
    '올가을',
    '올림픽',
    '올해',
    '옷차림',
    '와이셔츠',
    '와인',
    '완성',
    '완전',
    '왕비',
    '왕자',
    '왜냐하면',
    '왠지',
    '외갓집',
    '외국',
    '외로움',
    '외삼촌',
    '외출',
    '외침',
    '외할머니',
    '왼발',
    '왼손',
    '왼쪽',
    '요금',
    '요일',
    '요즘',
    '요청',
    '용기',
    '용서',
    '용어',
    '우산',
    '우선',
    '우승',
    '우연히',
    '우정',
    '우체국',
    '우편',
    '운동',
    '운명',
    '운반',
    '운전',
    '운행',
    '울산',
    '울음',
    '움직임',
    '웃어른',
    '웃음',
    '워낙',
    '원고',
    '원래',
    '원서',
    '원숭이',
    '원인',
    '원장',
    '원피스',
    '월급',
    '월드컵',
    '월세',
    '월요일',
    '웨이터',
    '위반',
    '위법',
    '위성',
    '위원',
    '위험',
    '위협',
    '윗사람',
    '유난히',
    '유럽',
    '유명',
    '유물',
    '유산',
    '유적',
    '유치원',
    '유학',
    '유행',
    '유형',
    '육군',
    '육상',
    '육십',
    '육체',
    '은행',
    '음력',
    '음료',
    '음반',
    '음성',
    '음식',
    '음악',
    '음주',
    '의견',
    '의논',
    '의문',
    '의복',
    '의식',
    '의심',
    '의외로',
    '의욕',
    '의원',
    '의학',
    '이것',
    '이곳',
    '이념',
    '이놈',
    '이달',
    '이대로',
    '이동',
    '이렇게',
    '이력서',
    '이론적',
    '이름',
    '이민',
    '이발소',
    '이별',
    '이불',
    '이빨',
    '이상',
    '이성',
    '이슬',
    '이야기',
    '이용',
    '이웃',
    '이월',
    '이윽고',
    '이익',
    '이전',
    '이중',
    '이튿날',
    '이틀',
    '이혼',
    '인간',
    '인격',
    '인공',
    '인구',
    '인근',
    '인기',
    '인도',
    '인류',
    '인물',
    '인생',
    '인쇄',
    '인연',
    '인원',
    '인재',
    '인종',
    '인천',
    '인체',
    '인터넷',
    '인하',
    '인형',
    '일곱',
    '일기',
    '일단',
    '일대',
    '일등',
    '일반',
    '일본',
    '일부',
    '일상',
    '일생',
    '일손',
    '일요일',
    '일월',
    '일정',
    '일종',
    '일주일',
    '일찍',
    '일체',
    '일치',
    '일행',
    '일회용',
    '임금',
    '임무',
    '입대',
    '입력',
    '입맛',
    '입사',
    '입술',
    '입시',
    '입원',
    '입장',
    '입학',
    '자가용',
    '자격',
    '자극',
    '자동',
    '자랑',
    '자부심',
    '자식',
    '자신',
    '자연',
    '자원',
    '자율',
    '자전거',
    '자정',
    '자존심',
    '자판',
    '작가',
    '작년',
    '작성',
    '작업',
    '작용',
    '작은딸',
    '작품',
    '잔디',
    '잔뜩',
    '잔치',
    '잘못',
    '잠깐',
    '잠수함',
    '잠시',
    '잠옷',
    '잠자리',
    '잡지',
    '장관',
    '장군',
    '장기간',
    '장래',
    '장례',
    '장르',
    '장마',
    '장면',
    '장모',
    '장미',
    '장비',
    '장사',
    '장소',
    '장식',
    '장애인',
    '장인',
    '장점',
    '장차',
    '장학금',
    '재능',
    '재빨리',
    '재산',
    '재생',
    '재작년',
    '재정',
    '재채기',
    '재판',
    '재학',
    '재활용',
    '저것',
    '저고리',
    '저곳',
    '저녁',
    '저런',
    '저렇게',
    '저번',
    '저울',
    '저절로',
    '저축',
    '적극',
    '적당히',
    '적성',
    '적용',
    '적응',
    '전개',
    '전공',
    '전기',
    '전달',
    '전라도',
    '전망',
    '전문',
    '전반',
    '전부',
    '전세',
    '전시',
    '전용',
    '전자',
    '전쟁',
    '전주',
    '전철',
    '전체',
    '전통',
    '전혀',
    '전후',
    '절대',
    '절망',
    '절반',
    '절약',
    '절차',
    '점검',
    '점수',
    '점심',
    '점원',
    '점점',
    '점차',
    '접근',
    '접시',
    '접촉',
    '젓가락',
    '정거장',
    '정도',
    '정류장',
    '정리',
    '정말',
    '정면',
    '정문',
    '정반대',
    '정보',
    '정부',
    '정비',
    '정상',
    '정성',
    '정오',
    '정원',
    '정장',
    '정지',
    '정치',
    '정확히',
    '제공',
    '제과점',
    '제대로',
    '제목',
    '제발',
    '제법',
    '제삿날',
    '제안',
    '제일',
    '제작',
    '제주도',
    '제출',
    '제품',
    '제한',
    '조각',
    '조건',
    '조금',
    '조깅',
    '조명',
    '조미료',
    '조상',
    '조선',
    '조용히',
    '조절',
    '조정',
    '조직',
    '존댓말',
    '존재',
    '졸업',
    '졸음',
    '종교',
    '종로',
    '종류',
    '종소리',
    '종업원',
    '종종',
    '종합',
    '좌석',
    '죄인',
    '주관적',
    '주름',
    '주말',
    '주머니',
    '주먹',
    '주문',
    '주민',
    '주방',
    '주변',
    '주식',
    '주인',
    '주일',
    '주장',
    '주전자',
    '주택',
    '준비',
    '줄거리',
    '줄기',
    '줄무늬',
    '중간',
    '중계방송',
    '중국',
    '중년',
    '중단',
    '중독',
    '중반',
    '중부',
    '중세',
    '중소기업',
    '중순',
    '중앙',
    '중요',
    '중학교',
    '즉석',
    '즉시',
    '즐거움',
    '증가',
    '증거',
    '증권',
    '증상',
    '증세',
    '지각',
    '지갑',
    '지경',
    '지극히',
    '지금',
    '지급',
    '지능',
    '지름길',
    '지리산',
    '지방',
    '지붕',
    '지식',
    '지역',
    '지우개',
    '지원',
    '지적',
    '지점',
    '지진',
    '지출',
    '직선',
    '직업',
    '직원',
    '직장',
    '진급',
    '진동',
    '진로',
    '진료',
    '진리',
    '진짜',
    '진찰',
    '진출',
    '진통',
    '진행',
    '질문',
    '질병',
    '질서',
    '짐작',
    '집단',
    '집안',
    '집중',
    '짜증',
    '찌꺼기',
    '차남',
    '차라리',
    '차량',
    '차림',
    '차별',
    '차선',
    '차츰',
    '착각',
    '찬물',
    '찬성',
    '참가',
    '참기름',
    '참새',
    '참석',
    '참여',
    '참외',
    '참조',
    '찻잔',
    '창가',
    '창고',
    '창구',
    '창문',
    '창밖',
    '창작',
    '창조',
    '채널',
    '채점',
    '책가방',
    '책방',
    '책상',
    '책임',
    '챔피언',
    '처벌',
    '처음',
    '천국',
    '천둥',
    '천장',
    '천재',
    '천천히',
    '철도',
    '철저히',
    '철학',
    '첫날',
    '첫째',
    '청년',
    '청바지',
    '청소',
    '청춘',
    '체계',
    '체력',
    '체온',
    '체육',
    '체중',
    '체험',
    '초등학생',
    '초반',
    '초밥',
    '초상화',
    '초순',
    '초여름',
    '초원',
    '초저녁',
    '초점',
    '초청',
    '초콜릿',
    '촛불',
    '총각',
    '총리',
    '총장',
    '촬영',
    '최근',
    '최상',
    '최선',
    '최신',
    '최악',
    '최종',
    '추석',
    '추억',
    '추진',
    '추천',
    '추측',
    '축구',
    '축소',
    '축제',
    '축하',
    '출근',
    '출발',
    '출산',
    '출신',
    '출연',
    '출입',
    '출장',
    '출판',
    '충격',
    '충고',
    '충돌',
    '충분히',
    '충청도',
    '취업',
    '취직',
    '취향',
    '치약',
    '친구',
    '친척',
    '칠십',
    '칠월',
    '칠판',
    '침대',
    '침묵',
    '침실',
    '칫솔',
    '칭찬',
    '카메라',
    '카운터',
    '칼국수',
    '캐릭터',
    '캠퍼스',
    '캠페인',
    '커튼',
    '컨디션',
    '컬러',
    '컴퓨터',
    '코끼리',
    '코미디',
    '콘서트',
    '콜라',
    '콤플렉스',
    '콩나물',
    '쾌감',
    '쿠데타',
    '크림',
    '큰길',
    '큰딸',
    '큰소리',
    '큰아들',
    '큰어머니',
    '큰일',
    '큰절',
    '클래식',
    '클럽',
    '킬로',
    '타입',
    '타자기',
    '탁구',
    '탁자',
    '탄생',
    '태권도',
    '태양',
    '태풍',
    '택시',
    '탤런트',
    '터널',
    '터미널',
    '테니스',
    '테스트',
    '테이블',
    '텔레비전',
    '토론',
    '토마토',
    '토요일',
    '통계',
    '통과',
    '통로',
    '통신',
    '통역',
    '통일',
    '통장',
    '통제',
    '통증',
    '통합',
    '통화',
    '퇴근',
    '퇴원',
    '퇴직금',
    '튀김',
    '트럭',
    '특급',
    '특별',
    '특성',
    '특수',
    '특징',
    '특히',
    '튼튼히',
    '티셔츠',
    '파란색',
    '파일',
    '파출소',
    '판결',
    '판단',
    '판매',
    '판사',
    '팔십',
    '팔월',
    '팝송',
    '패션',
    '팩스',
    '팩시밀리',
    '팬티',
    '퍼센트',
    '페인트',
    '편견',
    '편의',
    '편지',
    '편히',
    '평가',
    '평균',
    '평생',
    '평소',
    '평양',
    '평일',
    '평화',
    '포스터',
    '포인트',
    '포장',
    '포함',
    '표면',
    '표정',
    '표준',
    '표현',
    '품목',
    '품질',
    '풍경',
    '풍속',
    '풍습',
    '프랑스',
    '프린터',
    '플라스틱',
    '피곤',
    '피망',
    '피아노',
    '필름',
    '필수',
    '필요',
    '필자',
    '필통',
    '핑계',
    '하느님',
    '하늘',
    '하드웨어',
    '하룻밤',
    '하반기',
    '하숙집',
    '하순',
    '하여튼',
    '하지만',
    '하천',
    '하품',
    '하필',
    '학과',
    '학교',
    '학급',
    '학기',
    '학년',
    '학력',
    '학번',
    '학부모',
    '학비',
    '학생',
    '학술',
    '학습',
    '학용품',
    '학원',
    '학위',
    '학자',
    '학점',
    '한계',
    '한글',
    '한꺼번에',
    '한낮',
    '한눈',
    '한동안',
    '한때',
    '한라산',
    '한마디',
    '한문',
    '한번',
    '한복',
    '한식',
    '한여름',
    '한쪽',
    '할머니',
    '할아버지',
    '할인',
    '함께',
    '함부로',
    '합격',
    '합리적',
    '항공',
    '항구',
    '항상',
    '항의',
    '해결',
    '해군',
    '해답',
    '해당',
    '해물',
    '해석',
    '해설',
    '해수욕장',
    '해안',
    '핵심',
    '핸드백',
    '햄버거',
    '햇볕',
    '햇살',
    '행동',
    '행복',
    '행사',
    '행운',
    '행위',
    '향기',
    '향상',
    '향수',
    '허락',
    '허용',
    '헬기',
    '현관',
    '현금',
    '현대',
    '현상',
    '현실',
    '현장',
    '현재',
    '현지',
    '혈액',
    '협력',
    '형부',
    '형사',
    '형수',
    '형식',
    '형제',
    '형태',
    '형편',
    '혜택',
    '호기심',
    '호남',
    '호랑이',
    '호박',
    '호텔',
    '호흡',
    '혹시',
    '홀로',
    '홈페이지',
    '홍보',
    '홍수',
    '홍차',
    '화면',
    '화분',
    '화살',
    '화요일',
    '화장',
    '화학',
    '확보',
    '확인',
    '확장',
    '확정',
    '환갑',
    '환경',
    '환영',
    '환율',
    '환자',
    '활기',
    '활동',
    '활발히',
    '활용',
    '활짝',
    '회견',
    '회관',
    '회복',
    '회색',
    '회원',
    '회장',
    '회전',
    '횟수',
    '횡단보도',
    '효율적',
    '후반',
    '후춧가루',
    '훈련',
    '훨씬',
    '휴식',
    '휴일',
    '흉내',
    '흐름',
    '흑백',
    '흑인',
    '흔적',
    '흔히',
    '흥미',
    '흥분',
    '희곡',
    '희망',
    '희생',
    '흰색',
    '힘껏'
];
//# sourceMappingURL=korean.js.map